// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Avatar Container */
.avatar-holder {
    position: relative;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-svg {
    width: 100%;
    height: 100%;
}

/* Avatar Visual Hint Animations (matching exercise visual hints) */
/* Using transform: scale() for cross-avatar compatibility (different pupil radii) */

/* Zoom - pupil size pulse */
.avatar-visualHint-zoom {
    animation: avatarZoomPulse 2s ease-in-out infinite;
    transform-origin: center;
}

@keyframes avatarZoomPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.5); }
}

/* Pulse - gentle size change */
.avatar-visualHint-pulse {
    animation: avatarGentlePulse 1.5s ease-in-out infinite;
    transform-origin: center;
}

@keyframes avatarGentlePulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.25); }
}

/* Blink - eyes narrow briefly (applied to pupil only, kept for backwards compat) */
.avatar-visualHint-blink {
    animation: avatarBlink 1s ease-in-out infinite;
    transform-origin: center;
}

@keyframes avatarBlink {
    0%, 75%, 100% { transform: scaleY(1); }
    85%, 90% { transform: scaleY(0.1); }
}

/* Blink for entire eye group (white + pupil + shine) - eyelid closing effect */
.avatar-eye-blink {
    animation: avatarEyeBlink 1s ease-in-out infinite;
}

@keyframes avatarEyeBlink {
    0%, 75%, 100% { transform: scaleY(1); }
    85%, 90% { transform: scaleY(0.05); }
}

/* Avatar Selector UI */
.avatar-selector-container {
    position: relative;
}

.avatar-selector-btn {
    background: transparent;
    border: none;
    color: var(--text-muted);
    font-size: 20px;
    padding: 8px;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-selector-btn:hover {
    color: var(--text-primary);
    background: var(--bg-secondary);
}

.avatar-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: var(--bg-secondary);
    border: 1px solid var(--border-secondary);
    border-radius: 12px;
    padding: 8px;
    z-index: 200;
    min-width: 180px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    animation: avatarDropdownFadeIn 0.2s ease-out;
}

@keyframes avatarDropdownFadeIn {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
}

.avatar-option {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 10px 12px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    color: var(--text-secondary);
    font-size: 14px;
    transition: all 0.15s ease;
    text-align: left;
}

.avatar-option:hover {
    background: var(--bg-tertiary);
    color: var(--text-primary);
}

.avatar-option.active {
    background: var(--bg-tertiary);
    color: var(--accent-primary);
    font-weight: 600;
}

.avatar-option-icon {
    font-size: 22px;
    width: 32px;
    text-align: center;
    flex-shrink: 0;
}

.avatar-option-label {
    flex: 1;
}

.avatar-dropdown-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 199;
}

/* Responsive */
@media (max-width: 768px) {
    .avatar-holder {
        margin: 24px auto;
    }
}

@media (max-width: 480px) {
    .avatar-holder {
        margin: 12px auto;
    }

    .avatar-dropdown {
        right: -40px;
        min-width: 160px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AvatarEyes.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,mEAAmE;AACnE,oFAAoF;;AAEpF,4BAA4B;AAC5B;IACI,kDAAkD;IAClD,wBAAwB;AAC5B;;AAEA;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,qBAAqB,EAAE;AACjC;;AAEA,+BAA+B;AAC/B;IACI,sDAAsD;IACtD,wBAAwB;AAC5B;;AAEA;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,sBAAsB,EAAE;AAClC;;AAEA,mFAAmF;AACnF;IACI,8CAA8C;IAC9C,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB,oBAAoB,EAAE;IACtC,WAAW,sBAAsB,EAAE;AACvC;;AAEA,+EAA+E;AAC/E;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB,oBAAoB,EAAE;IACtC,WAAW,uBAAuB,EAAE;AACxC;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,+BAA+B;IAC/B,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":["/* Avatar Container */\n.avatar-holder {\n    position: relative;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.avatar-svg {\n    width: 100%;\n    height: 100%;\n}\n\n/* Avatar Visual Hint Animations (matching exercise visual hints) */\n/* Using transform: scale() for cross-avatar compatibility (different pupil radii) */\n\n/* Zoom - pupil size pulse */\n.avatar-visualHint-zoom {\n    animation: avatarZoomPulse 2s ease-in-out infinite;\n    transform-origin: center;\n}\n\n@keyframes avatarZoomPulse {\n    0%, 100% { transform: scale(1); }\n    50% { transform: scale(1.5); }\n}\n\n/* Pulse - gentle size change */\n.avatar-visualHint-pulse {\n    animation: avatarGentlePulse 1.5s ease-in-out infinite;\n    transform-origin: center;\n}\n\n@keyframes avatarGentlePulse {\n    0%, 100% { transform: scale(1); }\n    50% { transform: scale(1.25); }\n}\n\n/* Blink - eyes narrow briefly (applied to pupil only, kept for backwards compat) */\n.avatar-visualHint-blink {\n    animation: avatarBlink 1s ease-in-out infinite;\n    transform-origin: center;\n}\n\n@keyframes avatarBlink {\n    0%, 75%, 100% { transform: scaleY(1); }\n    85%, 90% { transform: scaleY(0.1); }\n}\n\n/* Blink for entire eye group (white + pupil + shine) - eyelid closing effect */\n.avatar-eye-blink {\n    animation: avatarEyeBlink 1s ease-in-out infinite;\n}\n\n@keyframes avatarEyeBlink {\n    0%, 75%, 100% { transform: scaleY(1); }\n    85%, 90% { transform: scaleY(0.05); }\n}\n\n/* Avatar Selector UI */\n.avatar-selector-container {\n    position: relative;\n}\n\n.avatar-selector-btn {\n    background: transparent;\n    border: none;\n    color: var(--text-muted);\n    font-size: 20px;\n    padding: 8px;\n    cursor: pointer;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.avatar-selector-btn:hover {\n    color: var(--text-primary);\n    background: var(--bg-secondary);\n}\n\n.avatar-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 8px;\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-secondary);\n    border-radius: 12px;\n    padding: 8px;\n    z-index: 200;\n    min-width: 180px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n    animation: avatarDropdownFadeIn 0.2s ease-out;\n}\n\n@keyframes avatarDropdownFadeIn {\n    from { opacity: 0; transform: translateY(-8px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.avatar-option {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 10px 12px;\n    border: none;\n    background: transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    color: var(--text-secondary);\n    font-size: 14px;\n    transition: all 0.15s ease;\n    text-align: left;\n}\n\n.avatar-option:hover {\n    background: var(--bg-tertiary);\n    color: var(--text-primary);\n}\n\n.avatar-option.active {\n    background: var(--bg-tertiary);\n    color: var(--accent-primary);\n    font-weight: 600;\n}\n\n.avatar-option-icon {\n    font-size: 22px;\n    width: 32px;\n    text-align: center;\n    flex-shrink: 0;\n}\n\n.avatar-option-label {\n    flex: 1;\n}\n\n.avatar-dropdown-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 199;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .avatar-holder {\n        margin: 24px auto;\n    }\n}\n\n@media (max-width: 480px) {\n    .avatar-holder {\n        margin: 12px auto;\n    }\n\n    .avatar-dropdown {\n        right: -40px;\n        min-width: 160px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
